import { useEffect, useState, useRef} from 'react'
import Template from './Template'
import * as TXT from './../util/Texts'
import * as SG from '../style/Styles'
import * as U from './../util/UrlHttp'
import * as RankingService from './../services/Ranking.service'
import * as F from './../util/Functions'
import { IPosition } from '../interfaces/IPosition'
import BlockGame from '../components/game/BlockGame'
import * as GameService from './../services/Game.service'
import IconFlagSelector from '../components/IconFlagSelector'

const PerPage:number = 10

interface Limit {
  limit:number
}

export default function Dash() {
  
  const tableRef                        = useRef<any>(null)
  const refHeadT                        = useRef<any>(null)
  const [rankingUsers, setRankingUsers] = useState<any>([])
  const [userName, setUserName]         = useState<string|null>('')
  const [position, setPosition]         = useState<IPosition>()
  const [matchs, setMatchs]             = useState<any>([])
  const [results, setResults]           = useState<any>([])
  const [totalbets, setTotalBets]       = useState<number>(0)
  
  const getRanking = async (limit:number) => {

    setUserName(F.GetNameUser())

    const res = await RankingService.GetPositionUser(F.GetIDUser())

    if (res.data && res.data.status) 
      setPosition(res.data.position)

    const data:Limit = {limit:limit}
    const result     = await RankingService.GetRanking(data)

    if (result.data && result.data.status) {
      setTotalBets(result.data.totalMatchsEnd)
      setRankingUsers(result.data.rakings)
    }
    
  }

  const onScroll = () => { 
    
    if(refHeadT.current)
      refHeadT.current.scrollLeft = tableRef.current?.scrollLeft

  }

  const getGamesData = (dateFil:any) => {
 
    const dataT =  dateFil ?? F.formatUSData( F.getLocalDateForCountry() )
    getGamers(dataT < TXT.STARTED_DAY ? TXT.STARTED_DAY : dataT)

  }

  const getGamers = async (dateF:string) => {
    
    const result = await GameService.GetGamesByDate(dateF)

    if (result.data && result.data.status) {
      setMatchs(result.data.games)
      setResults(result.data.results)
    }

  }
  
  useEffect( ()=> {

    getRanking(PerPage)
    getGamesData(null)

  }, [])

  return (
    <Template>

      <SG.CenterItem> 
        <IconFlagSelector />
      </SG.CenterItem>
      
      <SG.Title className='title' style={{textAlign:'center'}}>{TXT.GERAL_RANK}</SG.Title>

      {totalbets > 0 && 
        <SG.Div className='blockTotalBets'>
          {TXT.MATCH_REALIZED} <span>{totalbets}</span>
        </SG.Div>
      }

      <SG.BoxWhite className='tableBoxWhite'>

      <SG.Div className="wrap">

        <SG.Div className="headers" ref={refHeadT}>
            <SG.Div className="scroller tracScrol">
                <SG.Div className="track ts1">
                    <SG.Div className="heading"></SG.Div>
                </SG.Div>
                <SG.Div className="track ts2">
                    <SG.Div className="heading"></SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading">{TXT.PG_ABR}</SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading ">{TXT.PC_ABR}</SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading ">{TXT.PV_ABR}</SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading">{TXT.DG_ABR}</SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading">{TXT.PP_ABR}</SG.Div>
                </SG.Div>
                <SG.Div className="track ts3 headerth">
                    <SG.Div className="heading">{TXT.AC_ABR}</SG.Div>
                </SG.Div>
            </SG.Div>
        </SG.Div>

        <SG.Div className="tracks tracScrol" ref={tableRef} onScroll={onScroll}>

        { rankingUsers.length > 0 && rankingUsers.map((rank:any, i:number)=>(

          <SG.Div className="track" key={i} >
            <SG.Div className="entry ts1 posRank">
              <SG.H3>{rank.position < 10 ? `0${rank.position}` : rank.position}</SG.H3>
            </SG.Div>
            <SG.Div className="entry ts2 nameUserRank">
              <SG.SubSubTitle className='rankSub'> {rank.name} </SG.SubSubTitle>
              {rank.sector} {rank.sector &&  <br /> } {rank.plant}
            </SG.Div>
            <SG.Div className="entry ts3">
              <SG.SubSubTitle className='rankSub center'>{rank.PG}</SG.SubSubTitle>
            </SG.Div>
            <SG.Div className="entry ts3 posRank">
              {rank.PC}
            </SG.Div>
            <SG.Div className="entry ts3 posRank">
              {rank.PV}
            </SG.Div>
            <SG.Div className="entry ts3 posRank">
              {rank.DG}
            </SG.Div>
            <SG.Div className="entry ts3 posRank">
              {rank.PP}
            </SG.Div>
            <SG.Div className="entry ts3 posRank">
              {rank.AC}
            </SG.Div>
          </SG.Div>
          )) }

        </SG.Div>
      </SG.Div>
      </SG.BoxWhite>

      <SG.BoxWhite>
        <SG.PADD style={{paddingLeft:40, paddingTop:20, paddingBottom:20}}>
          <SG.SmallTitle className='txtDestak'>{TXT.LEGEND}</SG.SmallTitle>
          <SG.DisableText className='legendTxt'>{TXT.PG}</SG.DisableText>
          <SG.DisableText className='legendTxt'>{TXT.PC}</SG.DisableText>
          <SG.DisableText className='legendTxt'>{TXT.PV}</SG.DisableText>
          <SG.DisableText className='legendTxt'>{TXT.DG}</SG.DisableText>
          <SG.DisableText className='legendTxt'>{TXT.PP}</SG.DisableText>
          <SG.DisableText className='legendTxt'>{TXT.AC}</SG.DisableText>
        </SG.PADD>
      </SG.BoxWhite>

      <SG.H3 className='namePosDestak'>{userName}{TXT.YOUT_POS}</SG.H3>
      
      <SG.Div className='bloxPosition'>
        <SG.Div className='contentPos'>{position && position.position}º {TXT.RANK}</SG.Div>
      </SG.Div>

      <SG.PADD>
      <SG.Div className='tableSimpleBox'>

        <SG.TableRankingFull style={{width:'70%'}}>
          <SG.Thead>
            <SG.TR>
              <SG.TH className='headerthsimple'>{TXT.PG_ABR}</SG.TH>
              <SG.TH className='headerthsimple'>{TXT.PC_ABR}</SG.TH>
              <SG.TH className='headerthsimple'>{TXT.PV_ABR}</SG.TH>
              <SG.TH className='headerthsimple'>{TXT.DG_ABR}</SG.TH>
              <SG.TH className='headerthsimple'>{TXT.PP_ABR}</SG.TH>
              <SG.TH className='headerthsimple'>{TXT.AC_ABR}</SG.TH>
            </SG.TR>
          </SG.Thead>

          <SG.TBody>
            <SG.TR>
              <SG.TD><SG.SubSubTitle className='rankSub center'>{position && position.PG}</SG.SubSubTitle></SG.TD>
              <SG.TD>{position && position.PC}</SG.TD>
              <SG.TD>{position && position.PV}</SG.TD>
              <SG.TD>{position && position.DG}</SG.TD>
              <SG.TD>{position && position.PP}</SG.TD>
              <SG.TD>{position && position.AC}</SG.TD>
            </SG.TR>
          </SG.TBody>
        </SG.TableRankingFull>
      </SG.Div>
    
      <SG.BoxGrey className='boxMatGrey'>
        <SG.SubSubTitle className='center'>{TXT.MATCH_DAY}</SG.SubSubTitle>
       
        <SG.Div className='boxMatchDay'>
          <SG.BoxBlocks className='BoxBlocks'>
            {matchs.length > 0 && 
              matchs.map((game:any, i:any) => (
                  <BlockGame
                      className='BlockGame'
                      key={i}
                      id={game.id}
                      infosData={game.infosMatch}
                      teamHome={F.translateTeamName(game.home_team)}
                      teamVisit={F.translateTeamName(game.visiting_team)}
                      iconHome={game.home_team_icon}
                      iconVisit={game.visiting_team_icon}
                      homeID={game.home_team_id}
                      VisitID={game.visiting_team_id}
                      resultMatch={results}
                      setResultMatch={setResults}
                      isResult={true}
                      isDash={true}
                    />
                ))
              }
          </SG.BoxBlocks>
          </SG.Div>
      </SG.BoxGrey>

      </SG.PADD>
    </Template>
  );

}
